import axios from "api/axios"
import {
  APIResponse,
  Config,
  ConfigWithURLParams,
  NoContentType,
} from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"
import { getFingerprint } from "utils/fingerprint"

import {
  AuthData,
  RefreshTokenResponse,
  SocialAccount,
  UserTokenResponse,
} from "./types"
import { urls } from "./urls"

export default {
  refreshToken: async ({
    data,
    ...options
  }: Config): Promise<APIResponse<RefreshTokenResponse>> => {
    try {
      const res = await axios.post(urls.refreshToken(), data, options)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  getUserToken: async ({
    data,
    ...options
  }: Config): Promise<APIResponse<UserTokenResponse>> => {
    try {
      const res = await axios.post(urls.getUserToken(), data, {
        ...options,
        headers: {
          ...options.headers,
          "device-id": await getFingerprint(),
        },
      })
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  verifyAccessToken: async ({
    data,
    ...options
  }: Config): Promise<APIResponse<{ verified: boolean }>> => {
    try {
      const res = await axios.post(urls.verifyAccessToken(), data, options)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  changePassword: async ({
    data,
  }: Config): Promise<APIResponse<NoContentType>> => {
    try {
      const res = await axios.post(urls.changePassword(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  generateAuthCode: async ({
    data,
  }: Config): Promise<APIResponse<{ code: string }>> => {
    try {
      const res = await axios.post(urls.generateAuthCode(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  signUp: async ({ data }: Config): Promise<APIResponse<AuthData>> => {
    try {
      const res = await axios.post(urls.signUp(), data, {
        headers: {
          "device-id": await getFingerprint(),
        },
      })
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  socialAuth: {
    list: async (): Promise<APIResponse<SocialAccount[]>> => {
      try {
        const res = await axios.get(urls.socialAuth.list())
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },
    link: async ({ data }: Config): Promise<APIResponse<SocialAccount>> => {
      try {
        const res = await axios.post(urls.socialAuth.link(), data)
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },

    unlink: async ({
      urlParams,
    }: ConfigWithURLParams): Promise<APIResponse<NoContentType>> => {
      try {
        const res = await axios.delete(urls.socialAuth.unlink(urlParams.id))
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },
  },
}
